import {
  getInvoices,
  downloadInvoice,
  downloadCSVInvoice,
  downloadTicket,
  downloadFatura
} from '../services/dashboardService'

import types from './types'

const { UPDATE_INVOICES, RESET_INVOICES } = types

export function fetchDashboardInvoices(planId, nextURL) {
  return dispatch =>
    getInvoices(planId, nextURL).then(invoices => {
      if (invoices && invoices.faturas) {
        dispatch({
          type: UPDATE_INVOICES,
          data: invoices.faturas,
          next: invoices.paginacao
        })
      }
    })
}

export function downloadInvoiceCSVFile(planId, invoiceId) {
  return () => downloadCSVInvoice(planId, invoiceId).then(result => result)
}

export function downloadTicketFile(planId, invoiceId) {
  return () => downloadTicket(planId, invoiceId).then(result => result)
}

export function downloadInvoiceFile(planId, year, month) {
  return () => downloadInvoice(planId, year, month).then(result => result)
}

export function resetDashboardInvoices() {
  return dispatch =>
    dispatch({
      type: RESET_INVOICES
    })
}

export function downloadFaturaFile(planId, invoiceId) {
  return () => downloadFatura(planId, invoiceId).then(result => result)
}



// WEBPACK FOOTER //
// ./src/alelo-logic/actions/fetchDashboardInvoices.js